import styled from 'styled-components';
import {Tooltip} from '@/components/Tooltip';
import {CHANNEL_TALK} from '@/router';
import {palette} from '@/styles';
import {ReactComponent as InfoIconSvg} from './assets/info.svg';

export const Infomation = () => {
  return (
    <Tooltip
      clickable={true}
      style={{zIndex: 1}}
      render={() => (
        <Root>
          <Title>확인해주세요</Title>
          <List>
            <li>유동 인구 데이터 기반의 해설은 준비 중입니다.</li>
            <li>
              본 해설 자료에 수록된 내용은 AI 모델에 의해 다양한 데이터를
              기반으로 생성하므로 당사는 그 정확성이나 완전성을 보장할 수
              없습니다.
            </li>
            <li>
              따라서 어떠한 경우에도 본 자료는 이용자의 투자 또는 창업 결과에
              대한 법적 책임 소재에 대한 증빙 자료로 사용될 수 없습니다.
            </li>
            <li>
              생성 AI 기술의 특성상 부정확하거나 잘못된 정보 등을 제공할
              가능성이 있습니다.
            </li>
            <li>
              마이프차 지도는 이용자가 찾고자 하는 정보가 전달
              <br />될 수 있도록 최선의 노력을 하고 있으나, 제공된
              <br />
              정보에 대한 이용 여부는 이용자가 신중히
              <br />
              판단해야 합니다.
            </li>
            <li>
              또한 서비스 이용 시 부정확한 정보라고 인식하신다면 언제든지{' '}
              <a href={CHANNEL_TALK} target="_blank" rel="noreferrer">
                고객센터
              </a>
              를 통해 편히 알려주시기 바랍니다.
            </li>
          </List>
        </Root>
      )}
    >
      <InfoIcon />
    </Tooltip>
  );
};

const Root = styled.div`
  color: ${palette.white};
  width: 252px;
  line-height: 1.5;
  padding: 2px 0;
`;

const Title = styled.div`
  font-size: 14px;
  font-weight: 700;
`;

const List = styled.ul`
  font-size: 12px;
  font-weight: 300;
  margin: 0;
  margin-top: 8px;
  padding-left: 10px;
  letter-spacing: -0.3px;
  li {
    list-style-type: '•  ';
  }
  a {
    text-decoration: underline;
    color: ${palette.linkPrimary};
    cursor: pointer;
  }
`;

const InfoIcon = styled(InfoIconSvg)`
  color: ${palette.gray400};
  cursor: pointer;
  outline: 0;
  &:hover {
    color: ${palette.gray800};
  }
`;
